import { createContext, useState, useEffect, useContext } from "react";
import { UserContext } from "./user.context";
import { getPriorities } from "../utils/contract.utils";

export const SubcontractContext = createContext({
    subContractors: [], setSubContractors: () => null,
    activeSubcontractor: null, setActiveSubcontractor: () => null,
    subcontractEditor: {}, setSubcontractEditor: () => null,
    newSubContractEditor: {}, setNewSubContractEditor: () => null,
    allPriorities: [], setAllPriorities: () => null
});

export const SubcontractProvider = ({children}) => {
    const {currentUser} = useContext(UserContext);
    const [subContractors, setSubContractors] = useState([]);
    const [activeSubcontractor, setActiveSubcontractor] = useState(null);
    const [subcontractEditor, setSubcontractEditor] = useState({
        editorOpen: false,
        showSave: true
    });
    const [newSubContractEditor, setNewSubContractEditor] = useState({
        editorOpen: false,
        showSave: true
    });
    const [allPriorities, setAllPriorities] = useState([]);

    useEffect(() => {
        if(!currentUser) return;
        getPriorities().then((data) => {
            setAllPriorities(data);
        }).catch(error => {
            console.error(error);
            setAllPriorities([]);
        });
    }, [currentUser]);

    const value = {
        subContractors, setSubContractors,
        activeSubcontractor, setActiveSubcontractor,
        subcontractEditor, setSubcontractEditor,
        newSubContractEditor, setNewSubContractEditor,
        allPriorities, setAllPriorities
    };

    return (
        <SubcontractContext.Provider value={value}>{children}</SubcontractContext.Provider>
    );
}